import type { Localization } from '@/app/components/search/common/Localization.ts';

// Both the results modal and the hotel detail section explain what sustainability means on the
// useful-information page, under its own anchor. That page is shared with the ranking explanation,
// so the link is derived from `rankingLink` by swapping the fragment.
const SUSTAINABILITY_USEFUL_INFO_ANCHOR = '#sustainability';

/**
 * The useful-information link for the sustainability copy, or '' when the market does not show it.
 * One place, so the two pages can never point at different anchors or disagree on the flag.
 */
export function getSustainabilityInfoLink(localization: Pick<Localization, 'rankingLink' | 'configValuesApp'>): string {
  if (!localization.configValuesApp.emissionsInfoLinkEnabled || !localization.rankingLink) return '';

  return `${localization.rankingLink.split('#')[0]}${SUSTAINABILITY_USEFUL_INFO_ANCHOR}`;
}
